import { MappingItem } from '@corratech/pylot-gtm/src/GTM'
import { pdpItemMapping } from 'stores/ooka_usa_store/components/OOKA/pylot-gtm/src/mapping/events/pdpItemMapping'

export const pdpUpSellProductsData = (
    itemMapping = pdpItemMapping()
): MappingItem => {
    return {
        upsell_products_list: {
            data_source: ['upsell_products'],
            mapping: itemMapping,
            strict: true
        }
    }
}
